"use client";
import React from "react";
import CommonLayout from "./CommonLayout";
import Img_1 from "../../assets/dummy/img.png";
import Img_2 from "../../assets/dummy/img_2.png";
import Img_3 from "../../assets/dummy/img_3.png";
import Image from "next/image";
import HeadingAndSubHeading from "./HeadingAndSubHeading";
import SearchRedirectBtn from "@/components/redirect_btn/SearchRedirectBtn";
import { MoveRight } from 'lucide-react';
import CommonText from "../text/CommonText";
import { FavouritesSection } from "../../types/homepage";
import Link from "next/link";
import { useCityFromUrl } from "../../lib/cityUtils";
import { useCityContext } from "../../lib/CityContext";

interface FavouritesProps {
  data?: FavouritesSection;
  isSSR?: boolean; // Add this prop to control rendering mode
}

const cards = [
  {
    title: "Activa",
    description: "Honda",
    imgUrl: Img_2,
  },
  {
    title: "Karizma XMR",
    description: "Hero",
    imgUrl: Img_1,
  },
  {
    title: "Classic 350",
    description: "Royal Enfield",
    imgUrl: Img_3,
  },
];

const Favourites: React.FC<FavouritesProps> = ({ data, isSSR = false }) => {
  // Get current city from URL
  const cityFromUrl = useCityFromUrl();
  const { getCityByFormattedName } = useCityContext();
  
  // Get the actual city name (not formatted URL name)
  const currentCity = cityFromUrl.name 
    ? getCityByFormattedName(cityFromUrl.name)
    : null;
  
  const cityName = currentCity?.name || undefined;
  
  return (
    <CommonLayout className="pt-8 md:pt-8 pb-[70px]">
      <section aria-labelledby="favourites-heading">
        <HeadingAndSubHeading
          heading={data?.heading || "RENTALS HANDPICKED FOR YOU"}
          cityName={cityName}
        />
        <div className="flex items-start justify-between flex-wrap gap-8 md:gap-0 mt-8" aria-label="Popular bike rentals">
        {cards.map((card, idx) => (
          <article
            key={idx}
            className="bg-white rounded-lg p-4 w-full md:w-[32%] shadow-[0_4px_24px_0_rgba(0,0,0,0.10)]"
          >
            <Image
              src={card.imgUrl}
              alt={`${card.title} - ${card.description}`}
              className="w-full h-[250px] object-cover"
              width={300}
              height={250}
              style={{ width: 'auto', height: 'auto',margin:"0 auto" }}
              loading="lazy"
              placeholder="blur"
              blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gHYSUNDX1BST0ZJTEUAAQEAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAH4AABAAEAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADb/2wBDABQODxIPDRQSEBIXFRQdHx4eHRoaHSQtJSEkMjU1LS0yMi4qLjgyPj4+Oj5CQkJCQkJCQkJCQkJCQkJCQkJCQkL/2wBDAR4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh7/wAARCAAIAAoDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdABmX/9k="
            />
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-500 text-[14px] font-normal">
                  {card.description}
                </p>
                <h3 className="text-[18px] font-medium text-black">
                  {card.title}
                </h3>
              </div>
              <div id={`favourite-button-${idx}`}>
                {isSSR ? (
                  // Static button for SSR
                  <Link 
                    href="/search"
                    className="bg-white hover:bg-gray-100 border border-gray-200 rounded-full text-[#F05A24] flex items-center justify-center w-[120px] h-[40px] transition-colors"
                    title={`View ${card.title} rentals`}
                  >
                    <CommonText className="text-[#F05A24] text-base flex items-center gap-2">View <MoveRight className="mt-1"/></CommonText>
                  </Link>
                ) : (
                  // Interactive button
                  <SearchRedirectBtn className="bg-white hover:bg-gray-100 border border-gray-200 rounded-full text-[#F05A24] flex items-center justify-center w-[120px] h-[40px]" analyticsName="favourites_button">
                    <CommonText className="text-[#F05A24] text-base flex items-center gap-2">View <MoveRight className="mt-1"/></CommonText>
                  </SearchRedirectBtn>
                )}
              </div>
            </div>
          </article>
        ))}
        </div>
      </section>
    </CommonLayout>
  );
};

export default Favourites;
